import { render, staticRenderFns } from "./merchant_setting.vue?vue&type=template&id=0e60612a&scoped=true&"
import script from "./merchant_setting.vue?vue&type=script&lang=js&"
export * from "./merchant_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60612a",
  null
  
)

export default component.exports